import { render, staticRenderFns } from "./ImportCSV.vue?vue&type=template&id=98a42978&scoped=true"
import script from "./ImportCSV.vue?vue&type=script&lang=js"
export * from "./ImportCSV.vue?vue&type=script&lang=js"
import style0 from "./ImportCSV.vue?vue&type=style&index=0&id=98a42978&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a42978",
  null
  
)

export default component.exports